import DOMPurify from "dompurify";

export const sanitize = (html: string, options: DOMPurify.Config = {}) => {
  return DOMPurify.sanitize(html, options).toString();
};
